import { createSlice, createAction, createEntityAdapter, createSelector } from "@reduxjs/toolkit";

export const downloadTranslatedFileGenerator = createAction("uploadFile/downloadTranslatedFileGenerator");

const uploadFileAdapter = createEntityAdapter({
  selectId: (segment) => segment.id,
});

const uploadFileSlice = createSlice({
  name: "uploadFile",
  initialState: uploadFileAdapter.getInitialState({
    loading: false,
    projectId: "",
    sizeError: false,
    typeError: false,
    show: false,
    error: false,
    fileCountError: false,
    wordsCountError: false,
    fileSizeError: false,
    completeFile: {},
    success: false,
    fileId: ""
  }),
  reducers: {
    fileIsLoading(state) {
      if (!state.loading) {
        state.loading = true;
      }
    },
    addTransUnits: (state, action) => {
      if (state.loading) {
        let result = action.payload.transUnits;
        state.loading = false;
        state.show = true;
        state.fileId = action.payload.fileId;
        uploadFileAdapter.addMany(state, result);
      }
    },
    downloadTranslatedFile: (state, action) => {
      state.completeFile = action.payload;
      state.isLoading = false;
      state.success = true;
    },
    showEditor: (state, action) => {
      state.show = action.payload;
    },
    showSizeError: (state, action) => {
      state.sizeError = action.payload;
    },
    filesCountError: (state, action) => {
      state.fileCountError = action.payload;
    },
    fileWordsCountError: (state, action) => {
      state.wordsCountError = action.payload;
      state.show = false;
    },
    fileTypeError: (state, action) => {
      state.typeError = action.payload;
      state.show = false;
    },
    closeErrorWindow: (state) => {
      state.typeError = false;
      state.sizeError = false;
      state.fileCountError = false;
    },
  },
});

//Selectors
export const fileSelectors = uploadFileAdapter.getSelectors((state) => state.uploadFile);

//Select file state
export const fileState = createSelector(
  (state) => state.uploadFile,
  (uploadFile) => uploadFile
);

export const { fileIsLoading, addTransUnits, showEditor, showSizeError, filesCountError, closeErrorWindow, fileWordsCountError, fileTypeError, downloadTranslatedFile } =
  uploadFileSlice.actions;
export default uploadFileSlice.reducer;
